import FormattedMessage from 'I18n/components/FormattedMessage';
import { ExclamationIcon } from 'foundations-assets/icons/components/ExclamationIcon';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getExpiringInXDays } from '../../utils/dateTimeUtils';
import { trackExamLinkClick } from '../../utils/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExpiringSoonWarningIcon = ({
  cert
}) => {
  if (!cert.expiresAt) return null;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.tableColumns.expiringInXDays",
        options: {
          count: getExpiringInXDays(cert.expiresAt)
        }
      }), /*#__PURE__*/_jsx("br", {}), cert.examLink && /*#__PURE__*/_jsx(Link, {
        href: cert.examLink,
        onClick: () => trackExamLinkClick(cert.certificationId, cert.certificationName),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.tableColumns.retakeExam"
        })
      })]
    }),
    children: /*#__PURE__*/_jsx(IconCircle, {
      backgroundColor: "icon-alert-default",
      borderWidth: "0",
      color: "fill-surface-default",
      icon: ExclamationIcon,
      padding: "50",
      size: "100"
    })
  });
};
export default ExpiringSoonWarningIcon;